import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/activity/close.png';
var _hoisted_1 = {
  class: "activity-common-ctn"
};
var _hoisted_2 = ["src"];
import { ref, computed, watch } from "vue";
import { Popup } from "vant";
import { Persistent } from "@/utils/cache/persistent";
import { ossStyleProcess } from "@/utils/tools";
export default {
  __name: 'PointDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    triggerType: {
      type: String,
      default: ""
    },
    trigger: {
      type: Object,
      default: function _default() {}
    }
  },
  emits: ["update:visible"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var imgRef = ref(null);
    var isLoadedImg = ref(false);
    var isShow = computed(function () {
      return props.visible && isLoadedImg.value;
    });
    function loadImg() {
      return _loadImg.apply(this, arguments);
    }
    function _loadImg() {
      _loadImg = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _props$trigger7, _props$trigger8;
        var key, _props$trigger9, localLimitInfo;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if ((_props$trigger7 = props.trigger) !== null && _props$trigger7 !== void 0 && (_props$trigger7 = _props$trigger7.popup) !== null && _props$trigger7 !== void 0 && _props$trigger7.is_open) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              // 判断是否要显示弹窗
              key = "".concat(props.triggerType, "_point");
              if (!((_props$trigger8 = props.trigger) !== null && _props$trigger8 !== void 0 && (_props$trigger8 = _props$trigger8.popup) !== null && _props$trigger8 !== void 0 && _props$trigger8.is_limit)) {
                _context4.next = 12;
                break;
              }
              if (!Persistent.getLocal(key)) {
                _context4.next = 10;
                break;
              }
              localLimitInfo = Persistent.getLocal(key); // 【有限制】且【当天】【已展示次数】大于或等于限制次数，则不要展示弹窗
              if (!(new Date().setHours(0, 0, 0, 0) === new Date(localLimitInfo.last_time_show).setHours(0, 0, 0, 0) && ((_props$trigger9 = props.trigger) === null || _props$trigger9 === void 0 || (_props$trigger9 = _props$trigger9.popup) === null || _props$trigger9 === void 0 ? void 0 : _props$trigger9.limit_count) === localLimitInfo.limit_count && localLimitInfo.had_show_count >= localLimitInfo.limit_count)) {
                _context4.next = 10;
                break;
              }
              isLoadedImg.value = false;
              emits("update:visible", false);
              return _context4.abrupt("return");
            case 10:
              _context4.next = 13;
              break;
            case 12:
              if (Persistent.getLocal(key)) {
                Persistent.removeLocal(key);
              }
            case 13:
              _context4.next = 15;
              return new Promise(function (resolve, reject) {
                var _props$trigger10;
                var img = new Image();
                img.src = (_props$trigger10 = props.trigger) === null || _props$trigger10 === void 0 || (_props$trigger10 = _props$trigger10.popup) === null || _props$trigger10 === void 0 || (_props$trigger10 = _props$trigger10.item) === null || _props$trigger10 === void 0 ? void 0 : _props$trigger10.image;
                img.onload = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        resolve(true);
                        handleChangePoint();
                      case 2:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                img.onerror = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        resolve(false);
                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
              });
            case 15:
              isLoadedImg.value = _context4.sent;
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _loadImg.apply(this, arguments);
    }
    function handleClose() {
      emits("update:visible", false);
    }
    watch(function () {
      return props.visible;
    }, /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        var _props$trigger;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(val && (_props$trigger = props.trigger) !== null && _props$trigger !== void 0 && (_props$trigger = _props$trigger.popup) !== null && _props$trigger !== void 0 && (_props$trigger = _props$trigger.item) !== null && _props$trigger !== void 0 && _props$trigger.image)) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return loadImg();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), {
      immediate: true
    });
    function handleChangePoint() {
      var _props$trigger2;
      // 显示弹窗后更新本地缓存
      if ((_props$trigger2 = props.trigger) !== null && _props$trigger2 !== void 0 && (_props$trigger2 = _props$trigger2.popup) !== null && _props$trigger2 !== void 0 && _props$trigger2.is_limit) {
        var _props$trigger3;
        var key = "".concat(props.triggerType, "_point");
        var limitInfoToSetLocal = {
          limit_count: (_props$trigger3 = props.trigger) === null || _props$trigger3 === void 0 || (_props$trigger3 = _props$trigger3.popup) === null || _props$trigger3 === void 0 ? void 0 : _props$trigger3.limit_count,
          last_time_show: Date.now(),
          had_show_count: 1
        };
        if (Persistent.getLocal(key)) {
          var _props$trigger4;
          var localLimitInfo = Persistent.getLocal(key);
          // 如果是今天且 限制次数与之前相等，则+1,否则重置为1
          if (new Date().setHours(0, 0, 0, 0) === new Date(localLimitInfo.last_time_show).setHours(0, 0, 0, 0) && ((_props$trigger4 = props.trigger) === null || _props$trigger4 === void 0 || (_props$trigger4 = _props$trigger4.popup) === null || _props$trigger4 === void 0 ? void 0 : _props$trigger4.limit_count) === localLimitInfo.limit_count) {
            limitInfoToSetLocal.had_show_count = localLimitInfo.had_show_count + 1;
          }
        }
        Persistent.setLocal(key, limitInfoToSetLocal);
      }
    }
    function handleChoose() {
      var _props$trigger5;
      if ((_props$trigger5 = props.trigger) !== null && _props$trigger5 !== void 0 && (_props$trigger5 = _props$trigger5.popup) !== null && _props$trigger5 !== void 0 && (_props$trigger5 = _props$trigger5.item) !== null && _props$trigger5 !== void 0 && _props$trigger5.is_redirect && props.trigger.popup.item.redirect_url) {
        location.href = props.trigger.popup.item.redirect_url;
      }
      emits("update:visible", false);
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(_unref(Popup), {
        show: isShow.value,
        "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
          return isShow.value = $event;
        }),
        round: "",
        style: {
          "background": "transparent",
          "height": "4.22rem"
        }
      }, {
        default: _withCtx(function () {
          var _props$trigger6;
          return [_createElementVNode("div", _hoisted_1, [isLoadedImg.value ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "imgStyle",
            src: _unref(ossStyleProcess)((_props$trigger6 = props.trigger) === null || _props$trigger6 === void 0 || (_props$trigger6 = _props$trigger6.popup) === null || _props$trigger6 === void 0 || (_props$trigger6 = _props$trigger6.item) === null || _props$trigger6 === void 0 ? void 0 : _props$trigger6.image, 'type_26'),
            onClick: handleChoose
          }, null, 8, _hoisted_2)) : _createCommentVNode("", true), _createElementVNode("img", {
            src: _imports_0,
            class: "close_img",
            onClick: handleClose
          })])];
        }),
        _: 1
      }, 8, ["show"]);
    };
  }
};